import { AppShell } from './layout/AppShell';
import { CreateProjectDialog, useProjects } from '@/features/projects';
import { CommandPalette, ShortcutSheet } from '@/features/search';
import { QuickAddDialog } from '@/features/tasks/QuickAddDialog';
import { NewTaskModal } from '@/features/tasks';
import { useGlobalShortcuts } from '@/hooks/useShortcuts';
import { useRealtime } from '@/hooks/useRealtime';

/** Feeds the shell the signed-in user, their projects, and the global overlays. */
export function ShellContainer() {
  const { data: projects } = useProjects();
  useGlobalShortcuts();
  useRealtime();

  return (
    <>
      <AppShell projects={(projects ?? []).map((p) => ({ key: p.key, name: p.name, icon: p.icon }))} />
      <CommandPalette />
      <ShortcutSheet />
      <QuickAddDialog />
      <CreateProjectDialog />
      <NewTaskModal />
    </>
  );
}
